// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"520e9b78","193":"3fc847f8","203":"07caa471","248":"2723c8d9","369":"3303610a","446":"0743fb2f","453":"2a5cea3a","570":"d897e83e","617":"0dccf5a1","726":"88ee4aee","747":"8909747e","799":"5ea13d35","878":"b80dbdf2","885":"30cc45b7"}[chunkId] + ".chunk.js";
};